import React from 'react'
import './header.scss';
import Logo from '../../assets/Logo.png'
 
 interface Proptype {
   title: string;
   breakTextMarker: string;
 }

export default function Header(props: Proptype) {
  function breakTextOn(){
    const { breakTextMarker, title } = props
    if(Boolean(breakTextMarker)){
      return title.split(breakTextMarker)
        .map((textChunk, i) => 
          <span key={i}>{textChunk}</span>
          )
      } 

      return <span>{title}</span>;
  }
  return (
    <header className="header-container">
      <div className="header-logo-container">
        <div>
          <img className="mellro-logo" alt="Mellro-logo" src={Logo} />
        </div>
      </div>
      <div className="title">
        {breakTextOn()}
      </div>
    </header>
  )
}
